import { render, staticRenderFns } from "./PortalDeleteuser.vue?vue&type=template&id=216d690d&scoped=true&"
import script from "./PortalDeleteuser.vue?vue&type=script&lang=js&"
export * from "./PortalDeleteuser.vue?vue&type=script&lang=js&"
import style0 from "./PortalDeleteuser.vue?vue&type=style&index=0&id=216d690d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d690d",
  null
  
)

export default component.exports